module.exports = __webpack_public_path__ + "images/emoji/footprints.501098f4e84b2eb34fab.png";